import Axios from '../lib/axios'
import store from '@/store'

class NewsService {
  async index () {
    const result = await Axios.authenticated().get('/articles', {})
    return result
  }

  async published (p) {
    const result = await Axios.authenticated().get('/articles/published', {
      params: {
        page: p
      }
    })
    return result
  }

  async byId (id) {
    const result = await Axios.authenticated().get(`/articles/manage/${id}`, {})
    return result
  }

  async bySlug (slug) {
    const result = await Axios.authenticated().get(`/articles/${slug}`, {})
    return result
  }

  async create (article) {
    let config = {
      onUploadProgress: e => store.state.currentProgress = Math.round(e.loaded * 100 / e.total)
    }
    const result = await Axios.authenticated().post(
      `/articles`,
      article,
      config
    )
    return result
  }

  async update (article) {
    let editedArticle = JSON.parse(article.get('article'))
    let config = {
      onUploadProgress: e => store.state.currentProgress = Math.round(e.loaded * 100 / e.total)
    }
    const result = await Axios.authenticated().put(
      `/articles/manage/${editedArticle._id}`,
      article, 
      config
    )
    return result
  }

  async delete (article) {
    const result = await Axios.authenticated().delete(`/articles/manage/${article._id}`, { data: article })
    return result
  }

}

export default new NewsService()
